/* ════════════════════════════════════════════════════════
   ForceActive — Main JS v2  (vanilla ES modules)
   Porte tous les hooks React de ForceActive-v2-preview.html
════════════════════════════════════════════════════════ */

const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const isTouch  = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

/* ── Scroll progress bar ── */
function initScrollProgress() {
  const bar = document.getElementById('fa-progress-bar');
  if (!bar) return;
  const update = () => {
    const pct = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
    bar.style.width = pct + '%';
  };
  window.addEventListener('scroll', update, { passive: true });
}

/* ── Scroll reveal (IntersectionObserver) ── */
function initScrollReveal() {
  const els = document.querySelectorAll('.fa-reveal');
  if (!els.length) return;
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  els.forEach(el => obs.observe(el));
}

/* ── animate-on-scroll (animations.css) ── */
function initAnimateOnScroll() {
  const els = document.querySelectorAll('.animate-on-scroll');
  if (!els.length) return;
  // Stagger auto sur enfants de .stagger-children
  document.querySelectorAll('.stagger-children').forEach(parent => {
    parent.querySelectorAll('.animate-on-scroll').forEach((child, i) => {
      child.style.transitionDelay = (i * 80) + 'ms';
    });
  });
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
        e.target.addEventListener('transitionend', () => {
          e.target.style.willChange = 'auto';
        }, { once: true });
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });
  els.forEach(el => obs.observe(el));
}

/* ── Cursor glow ── */
function initCursorGlow() {
  if (isTouch) return;
  let glow = document.getElementById('fa-cursor-glow');
  if (!glow) { glow = document.createElement('div'); glow.id = 'fa-cursor-glow'; document.body.appendChild(glow); }
  let raf, tx = 0, ty = 0, cx = 0, cy = 0;
  const lerp = (a, b, t) => a + (b - a) * t;
  const onMove = (e) => { tx = e.clientX; ty = e.clientY; glow.style.opacity = '1'; };
  const onLeave = () => { glow.style.opacity = '0'; };
  const tick = () => {
    cx = lerp(cx, tx, 0.08); cy = lerp(cy, ty, 0.08);
    glow.style.left = cx + 'px'; glow.style.top = cy + 'px';
    raf = requestAnimationFrame(tick);
  };
  document.addEventListener('mousemove', onMove);
  document.addEventListener('mouseleave', onLeave);
  raf = requestAnimationFrame(tick);
}

/* ── Hero parallax ── */
function initHeroParallax() {
  if (isTouch || reduced) return;
  const img = document.querySelector('.fa-hero-bg-img');
  if (!img) return;
  const fn = () => { img.style.transform = `translateY(${window.scrollY * 0.35}px) scale(1.1)`; };
  window.addEventListener('scroll', fn, { passive: true });
}

/* ── Header scroll state + masquage directionnel ── */
function initHeaderScroll() {
  const header = document.querySelector('.fa-header');
  if (!header) return;
  let lastY = 0, ticking = false;
  const update = () => {
    const y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 30);
    if (y > 200) {
      if (y - lastY > 5)       header.classList.add('is-hidden');
      else if (lastY - y > 5)  header.classList.remove('is-hidden');
    } else {
      header.classList.remove('is-hidden');
    }
    lastY = y; ticking = false;
  };
  window.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
}

/* ── Bento stagger ── */
function initBentoStagger() {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-in'); });
  }, { threshold: 0.08 });
  ['.fa-bento-hero', '.fa-bento-sm-1', '.fa-bento-sm-2'].forEach(sel => {
    const el = document.querySelector(sel); if (el) obs.observe(el);
  });
}

/* ── Manifesto reveal — handled inline in fa-manifesto.liquid ── */
function initManifestoReveal() {}

/* ── Squarespace-style global scroll reveal (inline styles) ── */
function initSquarespaceReveal() {
  var TRANS = 'opacity 0.75s ease, transform 0.75s ease';
  var pool  = [];

  function hide(el) {
    el.style.opacity    = '0';
    el.style.transform  = 'translateY(32px)';
    el.style.transition = TRANS;
  }
  function show(el) {
    el.style.opacity   = '1';
    el.style.transform = 'translateY(0)';
  }

  var skip = ['.fa-hero-maquette','.fa-header','.fa-manifesto-text','.fa-hero-bg-img','.fa-hero-overlay'];

  var sel = [
    'h2','h3',
    '.fa-product-card','.fa-cs-card',
    '.fa-labo-line','.fa-stat-item',
    '.fa-review-card','.fa-partner-emblem',
    '.fa-trust-item','.fa-feature-item',
    '.fa-labo-eyebrow','.fa-labo-h2',
    '.fa-cs-title','.fa-cs-eyebrow',
    '.fa-btn-primary',
  ].join(',');

  document.querySelectorAll(sel).forEach(function(el) {
    if (el.dataset.sqsp) return;
    if (skip.some(function(s){ return el.closest(s); })) return;
    if (el.classList.contains('fa-line-inner')) return;
    el.dataset.sqsp = '1';
    hide(el);
    pool.push(el);
  });

  if (!pool.length) return;

  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (!e.isIntersecting) return;
      show(e.target);
      obs.unobserve(e.target);
    });
  }, { threshold: 0 });

  pool.forEach(function(el) { obs.observe(el); });

  /* Sécurité : tout révéler après 5s si l'observer ne tire pas */
  setTimeout(function() { pool.forEach(show); }, 5000);
}

/* ── Spec counters ── */
function initSpecCounters() {
  const section = document.querySelector('.fa-specs');
  if (!section) return;
  let fired = false;
  const obs = new IntersectionObserver(([e]) => {
    if (e.isIntersecting && !fired) {
      fired = true;
      document.querySelectorAll('.fa-specs-item').forEach((el, i) => {
        setTimeout(() => el.classList.add('is-line-in'), i * 80);
      });
      document.querySelectorAll('.fa-spec-num').forEach(el => {
        const target = parseFloat(el.dataset.target);
        if (isNaN(target)) return;
        const isFloat = String(target).includes('.');
        const duration = 1200;
        const start = performance.now();
        const step = (now) => {
          const t = Math.min((now - start) / duration, 1);
          const ease = 1 - Math.pow(1 - t, 3);
          el.textContent = isFloat ? (target * ease).toFixed(1) : Math.round(target * ease);
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }
  }, { threshold: 0.3 });
  obs.observe(section);
}

/* ── Text scramble on eyebrow ── */
function initScramble() {
  const el = document.querySelector('.fa-hero-eyebrow[data-scramble]');
  if (!el || reduced) return;
  const text = el.dataset.scramble;
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789—·';
  let frame = 0;
  const totalFrames = 18;
  const iv = setInterval(() => {
    frame++;
    if (frame >= totalFrames) { el.textContent = text; clearInterval(iv); return; }
    el.textContent = text.split('').map((ch, i) => {
      if (ch === ' ' || ch === '—') return ch;
      if (i < Math.floor((frame / totalFrames) * text.length)) return ch;
      return chars[Math.floor(Math.random() * chars.length)];
    }).join('');
  }, 50);
}

/* ── Magnetic buttons ── */
function initMagnetic() {
  if (isTouch || reduced) return;
  document.querySelectorAll('[data-magnetic]').forEach(el => {
    el.addEventListener('mousemove', (e) => {
      const rect = el.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = (e.clientX - cx) * 0.22;
      const dy = (e.clientY - cy) * 0.22;
      el.style.transform = `translate(${dx}px, ${dy}px)`;
    });
    el.addEventListener('mouseleave', () => { el.style.transform = 'translate(0,0)'; });
  });
}

/* ── 3D tilt cards ── */
function initTilt() {
  if (isTouch || reduced) return;
  document.querySelectorAll('.fa-product-card').forEach(el => {
    el.addEventListener('mousemove', (e) => {
      const rect = el.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;
      const rx = (y - 0.5) * -8;
      const ry = (x - 0.5) * 8;
      el.style.transform = `perspective(1000px) rotateX(${rx}deg) rotateY(${ry}deg)`;
      el.style.setProperty('--mx', `${x * 100}%`);
      el.style.setProperty('--my', `${y * 100}%`);
    });
    el.addEventListener('mouseleave', () => {
      el.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg)';
    });
  });
}

/* ── Partner hover color ── */
function initPartners() {
  document.querySelectorAll('.fa-partner-emblem[data-color]').forEach(el => {
    const color = el.dataset.color;
    el.addEventListener('mouseenter', () => { el.style.borderColor = color; el.style.color = color; });
    el.addEventListener('mouseleave', () => { el.style.borderColor = ''; el.style.color = ''; });
  });
}

/* ── Init all ── */
document.addEventListener('DOMContentLoaded', () => {
  initScrollProgress();
  initScrollReveal();
  initAnimateOnScroll();
  initHeaderScroll();
  initManifestoReveal();
  initSquarespaceReveal();
  initBentoStagger();
  initSpecCounters();
  initScramble();
  initMagnetic();
  initTilt();
  initPartners();
  if (!reduced) {
    initCursorGlow();
    initHeroParallax();
  }
});
